import Select, { MultiValue, SingleValue } from 'react-select';
import ProdutoModel from 'models/Produto';

export type Option = {
  label: string;
  value: number;
};

type BaseProps = {
  produtos: ProdutoModel[];
};

type SingleProps = BaseProps & {
  isMulti?: false;
  value: Option | null;
  onChange: (value: Option | null) => void;
};

type MultiProps = BaseProps & {
  isMulti: true;
  value: Option[];
  onChange: (value: Option[]) => void;
};

type SelectProdutosProps = SingleProps | MultiProps;

/**
 *
 Seleção de um campo
  <SelectProdutos
    produtos={produtos}
    onChange={setProdutoFiltrar}
    value={produtoFiltrar}
  />


 Seleção de multiplos campos
  <SelectProdutos
    produtos={produtosSelecao}
    onChange={setProdutosAssociados}
    value={Object.values(produtosAssociados)}
    isMulti
  />
 */
export default function SelectProdutos(
  props: SelectProdutosProps,
): JSX.Element {
  const { produtos, value, isMulti } = props;

  const options: Option[] = produtos.map(item => ({
    label: `${item.nome} (${item.ProdutoCategoria?.descricao})`,
    value: item.id,
  }));

  function criarOpcoes(option: Option, produtos2: ProdutoModel[]): Option {
    const produto = produtos2.find(p => p.id === option.value);

    return {
      value: option.value,
      label: `${produto?.nome} (${produto?.ProdutoCategoria?.descricao})`,
    };
  }

  let valueComDescricao: Option | Option[] | null = null;

  if (value) {
    if (isMulti) {
      valueComDescricao = (value as Option[]).map(v =>
        criarOpcoes(v, produtos),
      );
    } else {
      valueComDescricao = criarOpcoes(value as Option, produtos);
    }
  }

  const handleChange = (selected: MultiValue<Option> | SingleValue<Option>) => {
    if (props.isMulti) {
      props.onChange([...(selected as MultiValue<Option>)]);
    } else {
      props.onChange(selected as SingleValue<Option>);
    }
  };

  return (
    <Select<Option, boolean>
      placeholder="Selecione..."
      options={options}
      value={valueComDescricao}
      isMulti={isMulti}
      closeMenuOnSelect={!isMulti}
      onChange={handleChange}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      styles={{
        menuPortal: (base: any) => ({
          ...base,
          zIndex: 9999,
        }),
      }}
    />
  );
}
